import { AppVariant, BuildConfig } from '@config';
import { buildConfig as gbAmdea } from './gb/sidedoor-amdea/build/build-config';
import { buildConfig as gbPromo } from './gb/sidedoor-promo/build/build-config';
import { buildConfig as gbSda } from './gb/sidedoor-sda/build/build-config';
import { buildConfig as gbSidedoor } from './gb/sidedoor/build/build-config';
import { buildConfig as ieSidedoor } from './ie/sidedoor/build/build-config';

export const BUILD_CONFIGS: Record<AppVariant, BuildConfig> = {
  [AppVariant.GbSidedoor]: gbSidedoor,
  [AppVariant.GbSidedoorAmdea]: gbAmdea,
  [AppVariant.GbSidedoorSda]: gbSda,
  [AppVariant.GbSidedoorPromo]: gbPromo,
  [AppVariant.IeSidedoor]: ieSidedoor,
};
